var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'anx-content ' +
      (_vm.inverse !== null ? 'inversed-colors ' : '') +
      (_vm.first !== null ? 'first-no-nav ' : '')},[(_vm.title !== null)?_c('anx-title',{attrs:{"size":_vm.size,"noline":_vm.noline,"text":_vm.title}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }